<script setup>
  import { RouterView } from 'vue-router'
  import Topbar from "../components/topbar.vue";
  import Menu from "../components/mainNav.vue";
  import Feet from "../components/static/feet.vue";
  import FloatingButton from "../components/static/floating-button.vue";
</script>

<template>
  <div class="wrapper">
    <Topbar />
    <Menu />

    <div class="content-page">
      <div class="content">
        <div class="container-fluid">
          <RouterView />
        </div>
      </div>

      <Feet />
    </div>

    <FloatingButton />
  </div>
</template>
